<div #footerRef class="footer">
  <div class="footer-container">
    <div class="top scroll-fade">
      <div class="logo">
        <icon name="blauwtand"></icon>
        <!-- <div class="tagline">IT services & consulting</div> -->
        <!-- <div class="logo-gradient" aria-hidden="true"></div> -->
      </div>
      <div class="nav-links">
        <div class="eyebrow">Blauwtand</div>
        <a class="nav-link" routerLink="/vacatures">IT vacatures</a>
        <a class="nav-link" routerLink="/it-vacatures">IT vacatures per vakgebied</a>
        <a class="nav-link" routerLink="/opdrachtgevers">IT oplossingen opdrachtgevers</a>
        <a class="nav-link" routerLink="/open-sollicitatie">Open IT sollicitatie bij Blauwtand</a>
      </div>
      <div class="nav-links">
        <div class="eyebrow">Over ons</div>
        <a class="nav-link" routerLink="/over-blauwtand">Over Blauwtand</a>
        <a class="nav-link" routerLink="/stories">Blauwtand stories</a>
        <a class="nav-link" routerLink="/werken-bij">Werken bij Blauwtand</a>
        <a class="nav-link" href="/sitemap.xml" target="_blank" rel="noopener">Sitemap</a>
      </div>
      <div class="contact">
        <div class="eyebrow">Contact</div>
        <div class="contact-child">
          <icon name="call_filled"></icon>
          <div (click)="phoneCall('31798080320')">{{ phoneNumber }}</div>
        </div>
        <div class="contact-child">
          <icon name="whatsapp"></icon>
          <div (click)="whatsapp('31798080328')">{{ whatsAppNumber }}</div>
        </div>
        <div class="contact-child">
          <icon name="email_filled"></icon>
          <div (click)="email('info@blauwtand.com')">
            info&#64;blauwtand.com
          </div>
        </div>
      </div>
      <div class="socials">
        <div class="eyebrow">Volg ons</div>
        <icon name="facebook" (click)="redirectTo('facebook')"></icon>
        <!-- <icon name="twitter"  (click)="redirectTo('twitter')"></icon> -->
        <icon name="linkedin" (click)="redirectTo('linkedin')"></icon>
        <icon
          name="instagram"
          class="insta"
          (click)="redirectTo('instagram')"
        ></icon>
      </div>
    </div>
    <div class="bottom scroll-fade">
      <div>Copyright © {{ currentYear }} Blauwtand. All rights reserved.</div>
      <div class="kvk">KvK nr. 84981741.</div>
      <a class="privacy-policy" routerLink="/privacy-statement">Privacy statement.</a>
    </div>
  </div>
</div>
